import { render, staticRenderFns } from "./warningCode.vue?vue&type=template&id=5711e2ad&scoped=true"
import script from "./warningCode.vue?vue&type=script&lang=js"
export * from "./warningCode.vue?vue&type=script&lang=js"
import style0 from "./warningCode.vue?vue&type=style&index=0&id=5711e2ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5711e2ad",
  null
  
)

export default component.exports